import React, { Component } from "react";
import PropTypes from "prop-types";
import { UnfoldMoreRounded, UnfoldLessRounded } from "@mui/icons-material";

import { NoPrintDiv, LargeOnly } from "commons";

import { FilterSelectParent } from "./FilterSelectParent";
import { MenuButton } from "./MenuButton";

export class TransactionViewOptions extends Component {
    render() {
        const iconProps = { color: "primary", fontSize: "small", "aria-hidden": true };

        return (
            <LargeOnly enabled={this.props.isClientPortal}>
                <FilterSelectParent
                    filterSelect={this.props.filterSelect}
                    options={this.props.filterOptions}
                    ordinals={this.props.filterOrdinals}
                    disabled={this.props.buttonsDisabled}
                />
                <NoPrintDiv float="left">
                    <MenuButton
                        clickEvent={this.props.toggleInvestments}
                        icon={
                            this.props.isCollapsed ? (
                                <UnfoldMoreRounded {...iconProps} />
                            ) : (
                                <UnfoldLessRounded {...iconProps} />
                            )
                        }
                        text={this.props.isCollapsed ? "Show all" : "Hide all"}
                        disabled={this.props.buttonsDisabled}
                        hidden={this.props.expandHidden}
                    />
                </NoPrintDiv>
            </LargeOnly>
        );
    }
}

TransactionViewOptions.propTypes = {
    filterOptions: PropTypes.object,
    filterOrdinals: PropTypes.array,
    toggleInvestments: PropTypes.func,
    filterSelect: PropTypes.func,
    isCollapsed: PropTypes.bool,
    buttonsDisabled: PropTypes.bool,
    expandHidden: PropTypes.bool,
    handleSearch: PropTypes.func,
    assets: PropTypes.object,
    transactionTypes: PropTypes.object,
    isClientPortal: PropTypes.bool
};
